import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/webhooks')({
  component: WebhooksLayout,
})

function WebhooksLayout() {
  return <Outlet />
}
